import { render } from "./WalletBalance.vue?vue&type=template&id=dda15500&scoped=true"
import script from "./WalletBalance.vue?vue&type=script&lang=js"
export * from "./WalletBalance.vue?vue&type=script&lang=js"

import "./WalletBalance.vue?vue&type=style&index=0&id=dda15500&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dda15500"]])

export default __exports__